import { startApp } from '@horof/shared';
import { App } from './App';
import './finance.css';

// The treasurer writes the finances; the committee reads them (arqam doc 32).
startApp({ allow: ['treasurer', 'committee'], App });
